import axios from 'axios'

const AppointmentService = {
  async getList (params = {}) {
    return axios.get('admin/appointments', { params })
  },

  async show (id) {
    return axios.get(`admin/appointments/${id}`)
  },

  async store (data) {
    return axios.post('admin/appointments', data)
  },

  async update (id, data) {
    return axios.put(`admin/appointments/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/appointments/${id}`)
  },

  async updateStatus (id, data) {
    return axios.patch(`admin/appointments/${id}/status`, data)
  }
}

export default AppointmentService
